angular.module('fg').directive('fgWritingAssistButton', [
  '$timeout',
  'APP_CONFIG',
  'aiEditorService',
  function ($timeout, appConfig, aiEditorService) {
    return {
      restrict: 'A',
      link: function ($scope, $element) {
        var isImproving = false;
        var editor;

        function getEditor() {
          var editorContainer = $element.closest('.k-editor');
          return (
            editorContainer.data('kendoEditor') ||
            editorContainer
              .find('textarea[data-text-editor]')
              .data('kendoEditor')
          );
        }

        function getVisibleText(html) {
          return $('<div>')
            .html(html || '')
            .text()
            .trim();
        }

        function updateButton() {
          if (!editor) {
            return;
          }

          var hasContent = !!getVisibleText(editor.value());
          var isDisabled =
            !appConfig.enableWritingAssist || isImproving || !hasContent;

          $element.prop('disabled', isDisabled);
          $element.toggleClass('is-improving', isImproving);
          $element.attr('aria-busy', isImproving ? 'true' : 'false');
          $element.attr(
            'aria-label',
            isImproving ? 'Improving writing' : 'Improve writing with AI'
          );
          $element
            .find('.editor-writing-assist-label')
            .text(isImproving ? 'Improving...' : 'Improve writing');
        }

        function updateButtonInAngular() {
          $scope.$evalAsync(updateButton);
        }

        function onImproveWriting(event) {
          event.preventDefault();

          if (!editor || $element.prop('disabled')) {
            return;
          }

          isImproving = true;
          updateButton();

          aiEditorService.improveEditor(editor).finally(function () {
            if (editor.trigger) {
              editor.trigger('change');
            }
            $scope.$evalAsync(function () {
              isImproving = false;
              updateButton();
            });
          });
        }

        function bindEditor() {
          editor = getEditor();
          if (!editor) {
            return;
          }

          editor.bind('change', updateButtonInAngular);
          if (editor.body) {
            $(editor.body)
              .off('input.fgWritingAssistButton')
              .on('input.fgWritingAssistButton', updateButtonInAngular);
          }

          updateButton();
        }

        $element
          .on('mousedown.fgWritingAssistButton', function (event) {
            event.preventDefault();
          })
          .on('click.fgWritingAssistButton', onImproveWriting);

        $timeout(bindEditor);

        $scope.$on('$destroy', function () {
          $element.off('.fgWritingAssistButton');
          if (editor) {
            editor.unbind('change', updateButtonInAngular);
            if (editor.body) {
              $(editor.body).off('input.fgWritingAssistButton');
            }
          }
        });
      }
    };
  }
]);
